(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7439],{

/***/ 7195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/innovation",
      function () {
        return __webpack_require__(5441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6886);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SILink = (param)=>{
    let { children , onClick =(e)=>{} , ...props } = param;
    const handleOnClick = (e)=>{
        // @ts-ignore
        onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "".concat((_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(props.classes ? props.classes : ""),
        ...props,
        onClick: handleOnClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SILink);


/***/ }),

/***/ 5441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_innovation_index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(417);
/* harmony import */ var _styles_pages_innovation_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_innovation_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7037);
/* harmony import */ var _components_link_silink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5515);







// @ts-ignore
function Innovation(param) {
    let { InnovationList  } = param;
    /**
     * these variables are used to animate the left and right image when this view are on screen.
     */ const ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(ref, {
        once: false
    });
    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_innovation_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().banner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "details_container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "sidr_text",
                            children: "sidr"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "title_text",
                            children: "innovation"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "description",
                            children: "SIDR believes in nonstop innovation that results in nutritious food, accessible to everyone, while supporting and caring for our people and communities near and far."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_innovation_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "description",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: "buying honey online, 100% trusted."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "The goal has always been to grow beyond quality products to evolve with the changing behavior of consumers. We’ve recently stretched our innovation and brand across two categories: honey, and honey packet. Our most recent developments buying honey online include:"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "list_items",
                        children: InnovationList.map((innovation, index)=>{
                            var _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText, _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText1, _innovation_attributes_Image_data_attributes_alternativeText;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "item",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "detail",
                                        ref: innovation.attributes.Left_Animation_Image.data ? ref : null,
                                        children: [
                                            innovation.attributes.Left_Animation_Image.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "images ".concat(isInView ? "image_animation" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: innovation.attributes.Left_Animation_Image.data.attributes.url,
                                                        alt: (_innovation_attributes_Left_Animation_Image_data_attributes_alternativeText = innovation.attributes.Left_Animation_Image.data.attributes.alternativeText) !== null && _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText !== void 0 ? _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText : "SIDR",
                                                        fill: true
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: innovation.attributes.Right_Animation_Image.data.attributes.url,
                                                        alt: (_innovation_attributes_Left_Animation_Image_data_attributes_alternativeText1 = innovation.attributes.Left_Animation_Image.data.attributes.alternativeText) !== null && _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText1 !== void 0 ? _innovation_attributes_Left_Animation_Image_data_attributes_alternativeText1 : "SIDR",
                                                        fill: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "title_normal",
                                                children: "sidr"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "title_medium",
                                                children: innovation.attributes.Title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "info ".concat(innovation.attributes.Title),
                                                dangerouslySetInnerHTML: {
                                                    __html: innovation.attributes.Description
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link_silink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                href: "/" + innovation.attributes.Link,
                                                children: "shop now"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "img_box",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: innovation.attributes.Image.data.attributes.url,
                                            alt: (_innovation_attributes_Image_data_attributes_alternativeText = innovation.attributes.Image.data.attributes.alternativeText) !== null && _innovation_attributes_Image_data_attributes_alternativeText !== void 0 ? _innovation_attributes_Image_data_attributes_alternativeText : "SIDR",
                                            loading: "lazy",
                                            fill: true
                                        })
                                    })
                                ]
                            }, "innovation-" + index);
                        })
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Innovation);


/***/ }),

/***/ 6886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","link":"link_link__T8hPh","about-image-in":"link_about-image-in__JsJpN","fade-in-honeycomb":"link_fade-in-honeycomb__iJ7y6","dot-falling":"link_dot-falling__xjMoT","dot-falling-before":"link_dot-falling-before__Qz2nK","dot-falling-after":"link_dot-falling-after__fHF3N"};

/***/ }),

/***/ 417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"innovation_banner__tJLUI","container":"innovation_container__bfUry","about-image-in":"innovation_about-image-in__N2TO2","fade-in-honeycomb":"innovation_fade-in-honeycomb__z3cdO","dot-falling":"innovation_dot-falling__QXhPp","dot-falling-before":"innovation_dot-falling-before__8WqL9","dot-falling-after":"innovation_dot-falling-after__JqJ3K"};

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(7195); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);